import {UrlLocaleEnum, LocaleEnum} from '../types/locale';
import {validateLocale} from './validateLocale';

export const localeToPath = (locale: LocaleEnum) => {
  validateLocale(locale);
  let localeToPath: string = locale;

  // Locale.EN is used for international, so that the urlPath is actually /en/ instead of /us/
  if (localeToPath === LocaleEnum.EN) {
    localeToPath = 'en-EN';
  }

  const supportedLocaleKey = UrlLocaleEnum[localeToPath.split('-')[1].toUpperCase()];
  if (supportedLocaleKey) {
    return supportedLocaleKey;
  }
  throw new Error(`No UrlLocalEnum found for locale: ${localeToPath}`);
};
